const recordNativeVideoPlayed = (element: HTMLElement, file_id: string, order_item_id: string, order_id: string) => {
  if (!element.getAttribute('data-played')) {
    fetch('/apps/downloads/native_video_views/' + file_id, {
      method: 'post',
      body: JSON.stringify({ order_item_id: order_item_id, order_id: order_id }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
    element.setAttribute('data-played', 'true')
  }
}

export const initializeNativeVideo = (element: HTMLVideoElement) => {
  const file_id = element.getAttribute('data-file-id')
  const order_item_id = element.getAttribute('data-item-id')
  const order_id = element.getAttribute('data-order-id')
  if (file_id && order_id && order_item_id) {
    element.addEventListener('play', function () {
      recordNativeVideoPlayed(element, file_id, order_item_id, order_id)
    })
  }
}

export const initializeNativeVideos = (parent?: HTMLElement) => {
  const scope = parent || document

  scope.querySelectorAll<HTMLVideoElement>('video.sky-pilot-native-video').forEach((el) => {
    initializeNativeVideo(el)
  })
}
